import { Page, PageSkeleton } from '@/components';
import { useApi } from '@/api';
import {
  useTableProps,
  TextSearchFilter,
  DropdownFilter,
  Flex
} from '@blockanalitica/ui';
import WalletsTable from './WalletsTable';
// import BadDebtKpis from './BadDebtKpis';
import { useParams } from 'react-router';

type WalletsAssetsData = [{ value: string; label: string }];

type WalletsAssetsResponse = {
  supplied_assets: WalletsAssetsData;
  borrowed_assets: WalletsAssetsData;
};

export default function WalletsPage() {
  const { network } = useParams();

  const { pagination, filters } = useTableProps({
    filtersDebounceTime: 500,
    initialFilters: {
      textSearch: '',
      selectedSupplyOption: '',
      selectedBorrowOption: ''
    }
  });

  const [data, error] = useApi<WalletsAssetsResponse>({
    url: '/wallets/assets/'
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title="Active Wallets"
        actions={
          <Flex flexDirection={['column', 'row']} gap={['s', 'xs']}>
            <Flex gap={['s', 'xs']}>
              <DropdownFilter
                multi={true}
                withCryptoIcon={true}
                filterField="selectedSupplyOption"
                options={data.supplied_assets}
                cryptoIconProps={{ network }}
                pagination={pagination}
                titleFormat={(filteredCount: number) =>
                  `Supplied assets (${filteredCount})`
                }
                {...filters}
              />
              <DropdownFilter
                multi={true}
                withCryptoIcon={true}
                filterField="selectedBorrowOption"
                options={data.borrowed_assets}
                cryptoIconProps={{ network }}
                pagination={pagination}
                titleFormat={(filteredCount: number) =>
                  `Borrowed assets (${filteredCount})`
                }
                {...filters}
              />
            </Flex>
            <TextSearchFilter
              pagination={pagination}
              placeholder="Search by wallet"
              flex="1"
              display="flex"
              options={{
                variants: {
                  textSearchFilter: 'fullWidth'
                }
              }}
              {...filters}
            />
          </Flex>
        }>
        <WalletsTable
          url="/wallets/"
          tableFilters={{
            supplyAssetsFiltered:
              filters.filtersApplied['selectedSupplyOption'],
            borrowAssetsFiltered: filters.filtersApplied['selectedBorrowOption']
          }}
          textSearch={filters.filtersApplied['textSearch']}
          pagination={pagination}
        />
        {/*<BadDebtKpis />*/}
      </Page>
    );
  }

  return <PageSkeleton />;
}
